import { useCallback, useRef } from 'react';
export default function useDebounceCallback(callback, _a) {
    var _b = _a.leading, leading = _b === void 0 ? false : _b, maxWait = _a.maxWait, _c = _a.wait, wait = _c === void 0 ? maxWait || 0 : _c;
    var callbackRef = useRef(callback);
    callbackRef.current = callback;
    var prev = useRef(0);
    var trailingTimeout = useRef();
    var clearTrailing = function () { return trailingTimeout.current && clearTimeout(trailingTimeout.current); };
    var fn = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var now = Date.now();
        function call() {
            prev.current = now;
            clearTrailing();
            callbackRef.current.apply(null, args);
        }
        var last = prev.current;
        var offset = now - last;
        // leading
        if (last === 0) {
            if (leading) {
                call();
            }
            prev.current = now;
        }
        // body
        if (maxWait !== undefined) {
            if (offset > maxWait) {
                call();
                return;
            }
        }
        else if (offset < wait) {
            prev.current = now;
        }
        // trailing
        clearTrailing();
        trailingTimeout.current = setTimeout(function () {
            call();
            prev.current = 0;
        }, wait);
    }, [wait, maxWait, leading]);
    fn.cancel = clearTrailing;
    return fn;
}
